import { useQuery } from "react-query";
import { buildPackageTypeOptions, getLookups, getNewLookups } from "components/photography/lib/photoData";

export const usePackageTypes = ({ enabled }) => {
    return useQuery({
        queryKey: ["packageTypes"],
        initialData: [],
        queryFn: async () => {
            // return getLookups(true);
            const packageTypes = await getNewLookups();

            return buildPackageTypeOptions(packageTypes, true);
        },
        enabled,
    });
};
